<template>
  <div style="overflow-x: hidden;">
    <div :class="[forConasi ? 'look-up-voucher-conasi' : 'look-up-voucher']">
      <div class="form-group">
        <div class="form-look-up-voucher">
          <form>
            <div class="form-panel">
              <div class="row">
                <!-- EVoucherCode -->
                <div class="form-group col-12 col-md-3 mt-1">
                  <div class="col-xs-6">
                    <label for="inputVoucherCode"
                      >{{ $t("lookUpVoucher.voucherSerial") }}</label
                    >
                    <input
                      v-model="voucherSerial"
                      type="text"
                      class="form-control"
                      id="inputVoucherCode"
                      v-bind:class="{
                        'form-control': true,
                        'is-invalid':
                          !validate('voucherSerial') && fieldBlured.serial,
                      }"
                      v-on:blur="fieldBlured.serial = true"
                      @input="onInputVoucherCode"
                      @keydown.enter="handleShowTable($event)"
                    />
                    <span class="invalid-feedback" style="position:absolute;">{{
                      errorValidate.serial
                    }}</span>
                  </div>
                </div>
                <!-- Email -->
                <div class="form-group col-12 col-md-3 mt-1">
                  <div class="col-xs-6">
                    <label for="inputEmail"
                      >{{ $t("lookUpVoucher.email") }}</label
                    >
                    <input
                      v-model="email"
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      v-bind:class="{
                        'form-control': true,
                        'is-invalid': !validate('email') && fieldBlured.email,
                      }"
                      v-on:blur="fieldBlured.email = true"
                      @input="onInputEmailPhone"
                      @keydown.enter="handleShowTable($event)"
                    />
                    <span class="invalid-feedback" style="position:absolute;">{{
                      errorValidate.email
                    }}</span>
                  </div>
                </div>
                <!-- Phone -->
                <div class="form-group col-12 col-md-3 mt-1">
                  <div class="col-xs-6">
                    <label for="inputEmail">{{ $t("profile.phone") }}</label>
                    <input
                      v-model="phone"
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      v-bind:class="{
                        'form-control': true,
                        'is-invalid': !validate('phone') && fieldBlured.phone,
                      }"
                      v-on:blur="fieldBlured.phone = true"
                      @input="onInputEmailPhone"
                      @keydown.enter="handleShowTable($event)"
                    />
                    <span class="invalid-feedback" style="position:absolute;">{{
                      errorValidate.phone
                    }}</span>
                  </div>
                </div>
                <!-- Verification -->
                <div class="form-group col-12 col-md-3 mt-1">
                  <div class="col-xs-6">
                    <div class="header-form-group">
                      <label for="inputVerification"
                        >{{ $t("lookUpVoucher.verification") }}*</label
                      >
                      <span>{{ verificationValue }}</span>
                    </div>
                    <input
                      v-model="verification"
                      type="text"
                      class="form-control"
                      id="inputVerification"
                      v-bind:class="{
                        'form-control': true,
                        'is-invalid': !validate('verification') && fieldBlured.verification,
                        'shake-error': isShaking
                      }"
                      v-on:blur="fieldBlured.verification = true"
                      @keydown.enter="handleShowTable($event)"
                    />
                    <span class="invalid-feedback" style="position:absolute;">{{
                      errorValidate.verification
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="button-search pb-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  :class="{ 'shake-error': isShaking }"
                  @click="handleShowTable($event)"
                >
                  {{ $t("common.search") }}
                </button>
                <!-- <button
                  type="button"
                  class="btn btn-primary btn-sm ml-4"
                  @click="onReturnPreviousPage($event)"
                >
                  {{ $t("common.back") }}
                </button> -->
              </div>
            </div>
            <div class="content-voucher" v-if="showTableVoucher">
              <div v-if="!forConasi" class="divider-text bg-light" />
              <div class="info">
                <div class="col-xs-6">
                  <label class="headerSearchResult" for="inputFullname">{{
                    $t("lookUpVoucher.customer")
                  }}</label>
                  <input
                    v-model="customer"
                    type="text"
                    class="form-control"
                    id="inputFullname"
                    disabled
                  />
                </div>
              </div>
              <div class="table-info-voucher">
                <div
                  class="button-search m-0 p-0 mb-2 mr-3"
                  style="float: right;"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="sendAllVoucherInfoToEmail($event, false)"
                    v-if="voucherSelectedId.length > 0"
                  >
                    {{ $t("common.sendSelected", {num: voucherSelectedId.length}) }}
                  </button>
                  <span class="mx-1" />
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="sendAllVoucherInfoToEmail($event, true)"
                    v-if="voucherCustomerLookupList.length > 0"
                  >
                    {{ $t("common.sendAll") }}
                  </button>
                </div>
                <table class="table">
                  <thead class="thead">
                    <tr>
                      <th scope="col"> </th>
                      <th scope="col">{{ "#" }}</th>
                      <th scope="col">{{ $t("lookUpVoucher.voucherSerial") }}</th>
                      <th scope="col">{{ $t("lookUpVoucher.voucherName") }}</th>
                      <th scope="col">{{ $t("lookUpVoucher.supplier") }}</th>
                      <th scope="col">
                        {{
                          $t("lookUpVoucher.price") +
                            " / " +
                            $t("lookUpVoucher.voucherDiscount")
                        }}
                      </th>
                      <th scope="col">{{ $t("lookUpVoucher.validDate") }}</th>
                      <!-- <th scope="col">{{ $t('lookUpVoucher.expiredDate') }}</th> -->
                      <th scope="col">{{ $t("lookUpVoucher.status") }}</th>
                      <th scope="col">{{ $t("common.tools") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(eVoucher, index) in voucherCustomerLookupList"
                      :key="eVoucher + index"
                    >
                      <td>
                        <input v-if="!eVoucher.isExpired" type="checkbox" class="filled-in" :value="eVoucher.id" :id="eVoucher.id" v-model="voucherSelectedId" style="width: 18px; height: 18px;">
                      </td>
                      <td>{{ eVoucher.stt }}</td>
                      <td>{{ eVoucher.serial }}</td>
                      <td><b>{{ eVoucher.workpiece.name }}</b></td>
                      <td>{{ eVoucher.supplier }}</td>
                      <td class="text-right">
                        <div v-if="!eVoucher.workpiece.is_hide_price">
                        {{ eVoucher.price }}
                        {{ eVoucher.workpiece.type == VoucherIssuanceType.PRICE ? "VND" : "%" }}
                        </div>
                      </td>
                      <td :class="eVoucher.isExpired ? 'errorText' : ''" class="text-right">{{ eVoucher.expiredDate }}</td>
                      <td :class="eVoucher.isExpired ? 'errorText' : ''">{{ $t(getStatus(eVoucher.status, eVoucher.isExpired)) }}</td>
                      <td class="btn-search">
                        <button
                          v-if="eVoucher.hasSendEmail"
                          type="button"
                          class="btn btn-sm btn-resend-primary"
                          @click="resendVoucherInfo(eVoucher)"
                        >
                          {{ $t("common.sendEmail") }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate
                v-show="voucherCustomerLookupList.length > 0"
                :rows="paginator.totalPage"
                :per-page="paginator.perPage"
                :current-page="paginator.currentPage"
                :total-item="paginator.count"
                @onPageChange="pageChange"
                class="mx-2"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <loadingBar :useSlot="true" :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import dateUtils from "Utils/dateUtils";
import functionUtils from "Utils/functionUtils";
import voucherStatusType from "Enum/voucherStatusType";
import VoucherIssuanceType from "Enum/voucherIssuanceType";
import { FOR_CONASI_TARGET } from 'Utils/constants'
import moment from "moment";
export default {
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    showTableVoucher: false,
    verification: null,
    verificationValue: null,
    voucherSerial: null,
    email: null,
    voucherCustomerLookupList: [],
    customer: null,
    phone: null,
    errorCaptchaText: "",
    errorValidate: {
      email: "",
      serial: "",
      verification: "",
      phone: "",
    },
    fieldBlured: {
      serial: false,
      email: false,
      verification: false,
      phone: false,
    },
    paginator: {
      count: 0,
      currentPage: 1,
      totalPage: 1,
      rowPerPage: 1,
    },
    isShaking: false,
    isLoading: false,
    VoucherIssuanceType: VoucherIssuanceType,
    voucherSelectedId: [],
    hasSendAllEmail: false
  }),
  created() {
    this.verificationValue = Math.random()
      .toString()
      .slice(2, 6);

    this.voucherSerial = sessionStorage.getItem("voucherSerial")
    this.email = sessionStorage.getItem("email")
    this.phone = sessionStorage.getItem("phone")
    sessionStorage.removeItem("voucherSerial");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("phone");
  },
  computed: {
    ...mapGetters(["E_VOUCHER_LOOKUP_DATA"]),
  },
  watch: {
    E_VOUCHER_LOOKUP_DATA() {
      let res = this.E_VOUCHER_LOOKUP_DATA
      // Handle paginate
      this.paginator.count = res.paginate.count;
      this.paginator.currentPage = res.paginate.currentPage;
      this.paginator.totalPage = res.paginate.totalPage;
      this.paginator.rowPerPage = res.paginate.perPage / 2;
      // Handle response data
      let voucherData = res.results;
      this.voucherCustomerLookupList = [];
      this.customer = null
      let hasSendAllEmail = true
      for (let i = 0, size = voucherData.length; i < size; i++) {
        let currentDate = moment().format('YYYY-MM-DD')
        let expiredDate = dateUtils.formatDate(voucherData[i].expiredDate, dateUtils.STATIC_FORMAT_DATE_TIME_ZONE, dateUtils.STATIC_FORMAT_DATE_SQL)
        if (currentDate > expiredDate || voucherData[i].status == voucherStatusType.USED || functionUtils.isNull(voucherData[i].customerId)) {
          hasSendAllEmail = false
        }
        let voucherObj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          customerFullName: voucherData[i].customerFullName,
          serial: voucherData[i].serial,
          supplier: voucherData[i].supplier,
          price: voucherData[i] ? functionUtils.convertFormatNumberToMoney(voucherData[i].price) : 0,
          expiredDate: this.getDateEVoucher(voucherData[i].expiredDate),
          isExpired: this.isExpired(voucherData[i].expiredDate),
          status: voucherData[i].status,
          id: voucherData[i].id,
          workpiece: voucherData[i].workpiece,
          hasSendEmail: this.getHasSendEmail(voucherData[i].expiredDate, voucherData[i].status, voucherData[i].customerId),
        };
        if (this.customer == null) this.customer = voucherObj.customerFullName;
        this.voucherCustomerLookupList.push(voucherObj);
      }
      this.hasSendAllEmail = hasSendAllEmail
    },
  },
  methods: {
    isExpired: function(date) {
      let dateFormatter = dateUtils.formatDate(
        date,
        dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
        dateUtils.STATIC_FORMAT_DATE_SQL
      );
      let currentDate = moment().format("YYYY-MM-DD");
      if (currentDate <= dateFormatter) {
        return false;
      }
      return true;
    },
    /**
     * Get has send email
     */
    getHasSendEmail: function(date, status, customerId) {
      if (this.isExpired(date) || status == voucherStatusType.USED || functionUtils.isNull(customerId)) {
        return false;
      }
      return true;
    },
    /**
     * Send all voucher info to email
     */
    sendAllVoucherInfoToEmail: function(event, isSendAll) {
      event.preventDefault();
      this.$swal
        .fire({
          title: this.$t("sendVoucherInfoEmail.title"),
          text: this.$t("sendVoucherInfoEmail.content"),
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#A74528",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("common.agree"),
          cancelButtonText: this.$t("common.cancel"),
        })
        .then((result) => {
          if (result.value) {
            let filter = {
              serial: sessionStorage.getItem("voucherSerial"),
              email: sessionStorage.getItem("email"),
              phone: sessionStorage.getItem("phone"),
              voucherIds: isSendAll ? null : this.voucherSelectedId
            };
            this.isLoading = true;
            this.SEND_ALL_VOUCHER_INFO_TO_EMAIL(filter)
              .then(
                function() {
                  this.isLoading = false;
                  this.$swal.fire(
                    this.$t("sendVoucherInfoEmail.success.title"),
                    this.$t("sendVoucherInfoEmail.success.content"),
                    "success"
                  );
                }.bind(this)
              )
              .catch(
                function(error) {
                  this.isLoading = false;
                  this.$swal.fire(
                    this.$t("sendVoucherInfoEmail.error.title"),
                    this.$t(functionUtils.errorResponse(error.response)),
                    "error"
                  );
                }.bind(this)
              );
          }
        });
    },
    /**
     * Input voucher code
     */
    onInputVoucherCode: function() {
      // this.phone = null;
      // this.email = null;
    },
    /**
     * Input email or phone
     */
    onInputEmailPhone: function() {
      this.voucherSerial = null;
    },
    /**
     * Return previous page
     */
    onReturnPreviousPage: function() {
      this.$router.push({
        path: "introduction",
      });
      sessionStorage.removeItem("voucherSerial");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("phone");
    },
    /**
     * Resend voucher info
     */
    resendVoucherInfo(eVoucher) {
      let footerText = eVoucher.workpiece.is_hide_price ? `<div style="display: flex; justify-content: space-around; width: 100%;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">Hạn sử dụng: <span style="font-weight: bold;">${eVoucher.expiredDate}</span></span></div>` : `<div style="display: flex; justify-content: space-around; width: 100%;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">Giá tiền: <span style="font-weight: bold;">${eVoucher.price}</span></span><span style="color: #A74528;">Hạn sử dụng: <span style="font-weight: bold;">${eVoucher.expiredDate}</span></span></div>`
      this.$swal
        .fire({
          title: this.$t("sendVoucherInfoEmail.title"),
          text: this.$t("sendVoucherInfoEmail.content"),
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#A74528",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("common.agree"),
          cancelButtonText: this.$t("common.cancel"),
          footer: footerText,
        })
        .then((result) => {
          if (result.value) {
            let filter = {
              voucherId: eVoucher.id,
            };
            this.isLoading = true;
            this.SEND_VOUCHER_INFO_TO_EMAIL(filter)
              .then(
                function() {
                  this.isLoading = false;
                  this.$swal.fire(
                    this.$t("sendVoucherInfoEmail.success.title"),
                    this.$t("sendVoucherInfoEmail.success.content"),
                    "success"
                  );
                }.bind(this)
              )
              .catch(
                function(error) {
                  this.isLoading = false;
                  this.$swal.fire(
                    this.$t("sendVoucherInfoEmail.error.title"),
                    this.$t(functionUtils.errorResponse(error.response)),
                    "error"
                  );
                }.bind(this)
              );
          }
        });
    },
    validate: function(field) {
      switch (field) {
        case "serial":
          if (
            (!this.voucherSerial || this.voucherSerial == "") &&
            (!this.email || this.email == "") &&
            (!this.phone || this.phone == "")
          ) {
            this.errorValidate.serial = this.$t("common.requiredFields");
            return false;
          }
          break;
        case "email":
          if (
            (!this.email || this.email == "") &&
            (!this.phone || this.phone == "") &&
            (!this.voucherSerial || this.voucherSerial == "")
          ) {
            this.errorValidate.email = this.$t("common.requiredFields");
            return false;
          }
          break;
        case "phone":
          if (
            (!this.phone || this.phone == "") &&
            (!this.email || this.email == "") &&
            (!this.voucherSerial || this.voucherSerial == "")
          ) {
            this.errorValidate.phone = this.$t("common.requiredFields");
            return false;
          }
          break;
        case "verification":
          if (!this.verification || this.verification == "") {
            this.errorValidate.verification = this.$t("common.requiredFields");
            return false;
          } else if (this.verification != this.verificationValue) {
            this.errorValidate.verification = this.$t(
              "common.notificationToast.errorVerification"
            );
            return false;
          }
          break;
        default:
          break;
      }
      return true;
    },
    handleShowTable(event) {
      event.preventDefault()
      this.fieldBlured = {
        serial: true,
        email: true,
        verification: true,
        phone: true,
      };
      if (
        (this.validate("serial") ||
          this.validate("email") ||
          this.validate("phone")) &&
        this.validate("verification")
      ) {
        this.isShaking = false;
        this.showTableVoucher = true;
        this.voucherSelectedId = []
        this.customer = null
        this.lookupEVoucherCustomer();
        this.verificationValue = Math.random()
          .toString()
          .slice(2, 6);
        this.verification = null;
      } else {
        this.triggerShake();
      }
    },

    /**
     * Lookup e voucher customer
     */
    lookupEVoucherCustomer: function() {
      let voucherSerial = !functionUtils.isNull(this.voucherSerial)
        ? this.voucherSerial.trim()
        : "";
      let email = !functionUtils.isNull(this.email) ? this.email.trim() : "";
      let phone = !functionUtils.isNull(this.phone) ? this.phone.trim() : "";
      sessionStorage.setItem("voucherSerial", voucherSerial);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("phone", phone);
      let filter = {
        params: {
          page: this.paginator.currentPage,
          serial: voucherSerial,
          email: email,
          phone: phone,
        },
      };
      this.isLoading = true;
      this.LOOKUP_VOUCHER_CUSTOMER(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    /**
     * Page change
     */
    pageChange(page) {
      this.paginator.currentPage = page;
      this.lookupEVoucherCustomer();
    },

    // Get date e voucher
    getDateEVoucher: function(date) {
      if (!functionUtils.isNull(date)) {
        return dateUtils.formatDate(
          date,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },

    // Get status
    getStatus: function(status, isExpired) {
      if (status === voucherStatusType.ACTIVATED) {
        if (isExpired) {
          status === voucherStatusType.USING_EXPIRED
        }
      }
      return functionUtils.getVoucherStatusText(status)
    },

    triggerShake() {
      this.isShaking = true;
      setTimeout(() => {
        this.isShaking = false;
      }, 300);
    },

    ...mapActions([
      "SEND_VOUCHER_INFO_TO_EMAIL",
      "LOOKUP_VOUCHER_CUSTOMER",
      "SEND_ALL_VOUCHER_INFO_TO_EMAIL",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.look-up-voucher,
.look-up-voucher-conasi {
  font-size: 14px;

  .form-panel {
    background-color: $bg-primary;
    border-radius: 1em;
  }

  .form-group {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .title-form {
      font-family: Roboto;
      color: $text-primary;
      font-size: 15px;
      font-weight: 600;
    }

    .form-look-up-voucher {
      width: 100%;

      form {
        width: 100%;
        margin: 0 auto;
        // padding: 1rem;

        .row {
          justify-content: space-between;
          padding-left: 1rem;
          padding-right: 1rem;
          padding-top: 1rem;
        }

        input {
          height: 40px;
          border: none;
          color: $primary !important;
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

          &:focus {
            border: 1px solid $btn-background;
          }
        }

        label {
          color: $text-primary;
        }

        .headerSearchResult {
          color: $primary;
        }

        .header-form-group {
          display: flex;
          justify-content: space-between;

          span {
            display: flex;
            color: #fff;
            font-weight: 600;
            align-items: center;
            background-color: $btn-background;
            padding: 0 1rem;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
          }
        }

        .error-verification {
          color: #ff0000;
        }

        .button-search {
          display: flex;
          justify-content: center;
          button {
            font-weight: 600;
            color: #ffff;
            border: none;
            border-radius: 1rem;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
            background-color: $btn-background;
            padding: 0.5rem 1rem;

            &:hover {
              background-color: $primary;
            }

            &:active {
              background-color: #cf7156;
            }

            &:focus {
              outline: none;
            }
          }
        }

        .content-voucher {
          background-color: $white;
          border-radius: 1em;
          margin-top: 1em;
          .info {
            padding: 15px 15px 0px 15px;
          }
          .table-info-voucher {
            margin-top: 1rem;
            overflow-x: auto;
            table {
              .thead {
                background-color: $second;
                color: #fff;
              }
              tr {
                td {
                  color: $primary;
                }
              }
            }
          }
        }
      }
    }
  }

  ::-webkit-input-placeholder, /* Edge */
  :-ms-input-placeholder,
  ::placeholder {
    font-size: 14px;
    color: $primary;
  }

  input,
  select,
  textarea {
    color: $primary;
  }

  .errorText {
    color: red !important;
  }

  @media only screen and (min-width: 768px) {
    .col-md-3 {
      max-width: 40%;
      flex: 0 0 25%;
    }
  }
}

.look-up-voucher {
  .form-panel {
    background-color: whitesmoke;
    border-radius: 0;
  }

  .form-group {
    .form-look-up-voucher {

      form {
        input {
          color: $text-input-form !important;
        }
        label {
          color: black;
        }

        .headerSearchResult {
          color: $btn-background;
        }

        .content-voucher {
          background-color: whitesmoke;
          border-radius: 0;
          margin-top: 0;
          .table-info-voucher {
            table {
              .thead {
                background-color: $text-second;
                color: #fff;
              }
              tr {
                td {
                  color: $btn-background;
                }
              }
            }
          }
        }
      }
    }
  }
}

.divider-text {
  position: relative;
  text-align: center;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}

@media only screen and (min-width: 768px) {
  .look-up-voucher .col-md-3[data-v-aeaa6cc6] {
    max-width: 25%;
  }
}
.btn-resend-primary {
  background-color: $btn-background !important;
  color: $white;
}
:deep(.card) {
  border: none !important;
}
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}
.shake-error {
  animation: shake 0.3s ease-in-out;
  border-color: #dc3545 !important;
}
</style>
